"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const CameraIcon=({width:a=24,height:e=24,hidden:t=!1,title:r="Camera"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${a}"
    height="${e}"
    viewBox="0 0 36 36"
    aria-hidden=${t?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path d="M18 12a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6Z" />
    <path
      d="M33 8h-6.05l-3.352-3.674a1 1 0 0 0-.74-.326h-9.717a1 1 0 0 0-.739.326L9.05 8H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1ZM18 26.2a8.2 8.2 0 1 1 8.2-8.2 8.2 8.2 0 0 1-8.2 8.2Z"
    />
  </svg>`;
//# sourceMappingURL=Camera.js.map
